import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterTag_template } from "./filterTag_template";
import { filterArticle_template } from "./filterArticle_template";
import { filterVideo_template } from "./filterVideo_template";
import { filterListingPage_template } from "./filterListingPage_template";
import { filterUser_template } from "./filterUser_template";
import { vignettePreview_template } from "./vignettePreview_template";
import { buildStreamingServiceHtmlFromTag } from "../../utils/AffiliateLinkHelper";
import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { InsertDropdownController } from "../../utils/InsertDropdownController";

declare var ko: any;

export class vignettePickerInsertForm_template extends vnTemplate {
  protected parent: any;
  protected tagFilter: filterTag_template;
  protected articleFilter: filterArticle_template;
  protected videoFilter: filterVideo_template;
  protected listingPageFilter: filterListingPage_template;
  protected hubPageFilter: filterListingPage_template;
  protected imagePicker: imagePicker_template;
  protected imagePickerHelper: imagePickerHelper;
  protected imagePickerScrollBound: boolean = false;
  protected authorFilter: filterUser_template;
  protected insertDropdown: InsertDropdownController;

  protected getTemplateHtml(): string {
    return /* html */ `
        <div class="w-picker-form form-view" id="vignette-picker-view" data-bind="css: { 'is-visible': isShown }">

            <div class="picker-form">
                <div class="form-header w-justify">
                    <div class="w-left">
                    </div>
                    <div class="w-center">
                        <div class="section-title">
                            <h3 class="section-title">Insert Vignette</h3>
                        </div>
                    </div>
                    <div class="w-right">
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                </div>

                <div class="form-body" >

                    <div class="body-header w-justify">
                        <div class="w-left">
                        </div>
                        <div class="w-right">
                            <!-- ko if: isSingleInsertMode -->
                            <div class="insert-dropdown">
                              <button class="btn-icon insert-dropdown-toggle icon i-ins" type="button" data-bind="event: { click: onClickInsert.bind($data, false) }"><span>Insert</span></button>
                            </div>
                            <!-- /ko -->
                            <!-- ko ifnot: isSingleInsertMode -->
                            <div class="insert-dropdown" data-bind="css: { 'is-open': isInsertDropdownOpen }">
                              <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button" data-bind="event: { click: onClickToggleInsertDropdown }"><span>Insert</span></button>
                              <div class="insert-dropdown-list">
                                <button class="btn-icon icon i-ins" type="button" data-bind="event: { click: onClickInsert.bind($data, true) }" title="Insert with Dynamic Placement"><span>Dynamic Using Sentinel Avg. Scroll Depth %</span></button>
                                <button class="btn-icon icon i-ins" type="button" data-bind="event: { click: onClickInsert.bind($data, false) }" title="Insert without Dynamic Placement"><span>Static Placement</span></button>
                              </div>
                            </div>
                            <!-- /ko -->
                        </div>
                    </div>

                    <div class="article-header">
                        <div class="article-header-left">

                          <div class="form-group no-gap">
                            <label class="form-label">Name</label>
                            <h4 class="main-name" data-bind="text: name"></h4>
                          </div>

                          <div class="form-group">
                              <div class="variables-navigation">
                                  <div class="variable-navigation-section" data-bind="visible: customVariables().length">
                                      <button type="button" class="btn-f-s pill-btn pill-btn--black" style="display:block;" data-bind="event: { click: onClickCustomSection }, css: { 'is-active': isCustomVariableSectionActive() }">Custom</button>
                                  </div>

                                  <div data-bind="visible: brandVariables().length">
                                      <div class="form-sub-title no-margin" style="margin-top: 15px;">
                                        <strong>Brand</strong>
                                      </div>

                                      <div class="variable-navigation-section" style="margin-top:10px;">
                                          <button type="button" class="btn-f-s pill-btn pill-btn--black" style="display:block;" data-bind="text: brandOwner() ? brandOwner().name : 'Brand', event: { click: onClickBrandSection }, css: { 'is-active': isBrandVariableSectionActive() }"></button>
                                      </div>
                                  </div>

                                  <div class="variable-navigation-section" style="margin-top:20px;" data-bind="visible: tagVariables().length > 0">
                                      <strong class="form-sub-title no-margin" style="margin-bottom:16px; display: block;">Tags</strong>
                                      <strong class="form-label" data-bind="visible: !hideDestinationContextOptions()">Dynamic</strong>
                                      <div class="vignette-dynamic-data__section sub-section" data-bind="visible: tagVariables().length === 1 && !hideDestinationContextOptions()">
                                          <div class="form-check-inline width-auto flex">
                                            <input type="checkbox" id="vignette-dynamic-tags-destination-context" data-bind="checked: dynamicTagsDestinationListingPageOrArticle" />
                                            <label class="form-label icon i-check" for="vignette-dynamic-tags-destination-context">Destination Hub/Article</label>
                                          </div>
                                      </div>
                                      <strong class="form-label" style="margin-top: 10px;">Custom</strong>
                                      <div data-bind="foreach: tagVariables">
                                          <div class="variable-navigation-item">
                                              <button type="button" class="btn-f-s pill-btn pill-btn--black" data-bind="text: title, event: { click: onClick }, css: { 'is-active': isActive(), 'is-swap-source': isSwapSource() }"></button>
                                              <div class="variable-navigation-item-actions">
                                                <button type="button" class="icon i-x-after clear-btn" title="Clear values" data-bind="visible: hasValue(), event: { click: onClear }">Clear</button>
                                                <button type="button" class="icon i-update swap-btn" title="Swap with another tag" data-bind="visible: showSwap(), event: { click: onSwap }, css: { 'is-swap-source': isSwapSource() }, text: swapLabel"></button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="variable-navigation-section" style="margin-top:20px;" data-bind="visible: articleVariables().length">
                                      <strong class="form-sub-title no-margin" style="margin-bottom:16px; display: block;">Articles</strong>
                                      <strong class="form-label">Dynamic</strong>
                                      <div class="vignette-dynamic-data__section sub-section" data-bind="visible: !hideDestinationContextOptions()">
                                        <div class="form-check-inline width-auto flex">
                                          <input type="checkbox" id="vignette-dynamic-articles-destination-listing-page" data-bind="checked: dynamicArticlesDestinationListingPage, disable: dynamicArticlesDestinationDisabled" />
                                          <label class="form-label icon i-check" for="vignette-dynamic-articles-destination-listing-page">Destination Hub</label>
                                        </div>
                                      </div>
                                      <div class="vignette-dynamic-data__section sub-section">
                                        <div class="vignette-dynamic-data__filter">
                                          <label class="form-label">Hub</label>
                                          ${ this.listingPageFilter ? this.listingPageFilter.getHtmlBuild() : '' }
                                        </div>
                                        <div class="vignette-dynamic-data__article-source flex" style="justify-content: space-between; height: 3em;">
                                          <div class="form-check-inline width-auto flex">
                                            <input type="radio" id="vignette-dynamic-articles-pinned" name="vignette-dynamic-articles-source" style="width: 16px; height: 16px;" value="pinned" data-bind="checked: dynamicArticlesSource" />
                                            <label class="form-label icon i-radio" for="vignette-dynamic-articles-pinned">Pinned</label>
                                          </div>
                                          <div class="form-check-inline width-auto flex">
                                            <input type="radio" id="vignette-dynamic-articles-latest" name="vignette-dynamic-articles-source" style="width: 16px; height: 16px;" value="latest" data-bind="checked: dynamicArticlesSource" />
                                            <label class="form-label icon i-radio" for="vignette-dynamic-articles-latest">Latest</label>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vignette-dynamic-data__section sub-section">
                                        <div class="vignette-dynamic-data__filter">
                                          <label class="form-label">Author</label>
                                          ${ this.authorFilter ? this.authorFilter.getHtmlBuild() : '' }
                                          <div id="insert-form-selected-author"></div>
                                        </div>
                                      </div>
                                      <strong class="form-label" style="margin-top: 16px;">Custom</strong>
                                      <div data-bind="foreach: articleVariables">
                                        <div class="variable-navigation-item">
                                            <button type="button" class="btn-f-s pill-btn pill-btn--black" data-bind="text: title, event: { click: onClick }, css: { 'is-active': isActive(), 'is-swap-source': isSwapSource() }"></button>
                                            <div class="variable-navigation-item-actions">
                                              <button type="button" class="icon i-x-after clear-btn" title="Clear values" data-bind="visible: hasValue(), event: { click: onClear }">Clear</button>
                                              <button type="button" class="icon i-update swap-btn" title="Swap with another article" data-bind="visible: showSwap(), event: { click: onSwap }, css: { 'is-swap-source': isSwapSource() }, text: swapLabel"></button>
                                            </div>
                                        </div>
                                      </div>
                                  </div>

                                  <div class="variable-navigation-section" style="margin-top:10px;" data-bind="visible: imageVariables().length">
                                      <strong class="form-sub-title no-margin" style="display: block;">Images</strong>
                                      <div data-bind="foreach: imageVariables">
                                          <div class="variable-navigation-item">
                                              <button type="button" class="btn-f-s pill-btn pill-btn--black" data-bind="text: title, event: { click: onClick }, css: { 'is-active': isActive(), 'is-swap-source': isSwapSource() }"></button>
                                              <div class="variable-navigation-item-actions">
                                                <button type="button" class="icon i-x-after clear-btn" title="Clear values" data-bind="visible: hasValue(), event: { click: onClear }">Clear</button>
                                                <button type="button" class="icon i-update swap-btn" title="Swap with another image" data-bind="visible: showSwap(), event: { click: onSwap }, css: { 'is-swap-source': isSwapSource() }, text: swapLabel"></button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="variable-navigation-section" style="margin-top:10px;" data-bind="visible: videoVariables().length">
                                      <strong class="form-sub-title no-margin" style="display: block;">Videos</strong>
                                      <div data-bind="foreach: videoVariables">
                                          <div class="variable-navigation-item">
                                              <button type="button" class="btn-f-s pill-btn pill-btn--black" data-bind="text: title, event: { click: onClick }, css: { 'is-active': isActive(), 'is-swap-source': isSwapSource() }"></button>
                                              <div class="variable-navigation-item-actions">
                                                <button type="button" class="icon i-x-after clear-btn" title="Clear values" data-bind="visible: hasValue(), event: { click: onClear }">Clear</button>
                                                <button type="button" class="icon i-update swap-btn" title="Swap with another video" data-bind="visible: showSwap(), event: { click: onSwap }, css: { 'is-swap-source': isSwapSource() }, text: swapLabel"></button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="variable-navigation-section" style="margin-top:20px;" data-bind="visible: hubVariables().length > 0">
                                      <strong class="form-sub-title no-margin" style="display: block; margin-bottom: 16px;">Hubs</strong>
                                      <strong class="form-label" data-bind="visible: !hideDestinationContextOptions()">Dynamic</strong>
                                      <div class="vignette-dynamic-data__section sub-section" data-bind="visible: hubVariables().length === 1 && !hideDestinationContextOptions()">
                                          <div class="form-check-inline width-auto flex">
                                            <input type="checkbox" id="vignette-dynamic-hubs-destination-listing-page" data-bind="checked: dynamicHubsDestinationListingPage" />
                                            <label class="form-label icon i-check" for="vignette-dynamic-hubs-destination-listing-page">Destination Hub</label>
                                          </div>
                                      </div>
                                      <strong class="form-label" style="margin-top: 10px;" data-bind="visible: hubVariables().length === 1">Custom</strong>
                                      <div data-bind="foreach: hubVariables">
                                          <div class="variable-navigation-item">
                                              <button type="button" class="btn-f-s pill-btn pill-btn--black" data-bind="text: title, event: { click: onClick }, css: { 'is-active': isActive(), 'is-swap-source': isSwapSource() }"></button>
                                              <div class="variable-navigation-item-actions">
                                                <button type="button" class="icon i-x-after clear-btn" title="Clear values" data-bind="visible: hasValue(), event: { click: onClear }">Clear</button>
                                                <button type="button" class="icon i-update swap-btn" title="Swap with another hub" data-bind="visible: showSwap(), event: { click: onSwap }, css: { 'is-swap-source': isSwapSource() }, text: swapLabel"></button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                        </div>

                        <div class="article-header-right">

                          <div class="form-group">
                            <strong class="form-sub-title no-margin" data-bind="text: activeVariableTitle"></strong>
                          <div>
                              <!-- ko if: specsLoading -->
                              <span class="form-loading"></span>
                              <!-- /ko -->
                              <span class="text-muted" data-bind="text: specsFillMessage, visible: !specsLoading() && specsFillMessage"></span>
                            </div>
                            <div data-bind="visible: activeVariableType() == 'tag'">
                            ${ this.tagFilter ? this.tagFilter.getHtmlBuild() : '' }
                            </div>
                            <div data-bind="visible: activeVariableType() == 'article'">
                            ${ this.articleFilter ? this.articleFilter.getHtmlBuild() : '' }
                            </div>
                            <div data-bind="visible: activeVariableType() == 'image'">
                              <button type="button" class="btn icon i-image" data-bind="event: { click: onClickSelectImage }">Select Image</button>
                            </div>
                            <div data-bind="visible: activeVariableType() == 'video'">
                            ${ this.videoFilter ? this.videoFilter.getHtmlBuild() : '' }
                            </div>
                            <div data-bind="visible: activeVariableType() == 'hub'">
                            ${ this.hubPageFilter ? this.hubPageFilter.getHtmlBuild() : '' }
                            </div>
                          </div>

                          <div class="form-group" data-bind="if: variables && variables().length" style="margin-top:8px;">
                              <div class="variables-list" data-bind="foreach: selectedVariables">
                                <div class="variable-row" style="display:flex; gap:8px; align-items:center; margin-top:8px;">
                                  <label class="form-label" style="min-width:180px;" data-bind="text: name"></label>
                                  <input
                                    type="text"
                                    class="input-text"
                                    data-bind="
                                      textInput: value,
                                      disable: readOnly,
                                      attr: { placeholder: defaultValue }
                                    "
                                    style="flex:1;"
                                  />
                                  <button type="button" class="btn icon i-image" data-bind="visible: $parent.isImageUrlVariable($data), event: { click: $parent.onClickOverrideImageVariable }">Select Image</button>
                                </div>
                              </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            ${ this.imagePicker ? this.imagePicker.getHtmlBuild() : '' }
        </div>
        `;
  }

  protected getTemplateName(): string {
    return "vignettePickerInsertForm-template";
  }

  public setSingleInsertMode(enabled: boolean): void {
    this.getTemplateViewModel().isSingleInsertMode(enabled);
  }

  public setHideDestinationContextOptions(enabled: boolean): void {
    this.getTemplateViewModel().hideDestinationContextOptions(enabled);
  }

  protected buildViewModel(): any {
    let self = this;
    let viewModel: any = {
      isShown: ko.observable(false),
      idVignette: ko.observable(null),
      name: ko.observable(null),
      html: ko.observable(null),
      css: ko.observable(null),
      brandOwner: ko.observable(null),
      variables: ko.observableArray([]),
      variablesFromCard: ko.observableArray([]),
      references: ko.observable({ articles: [], tags: [], videos: [], images: [], hubs: [], listingPages: [], authors: [] }),
      dynamicArticlesDestinationListingPage: ko.observable(false),
      dynamicArticlesSource: ko.observable('latest'),
      dynamicArticlesListingPageSelected: ko.observable(false),
      dynamicArticlesAuthorSelected: ko.observable(false),
      dynamicHubsDestinationListingPage: ko.observable(false),
      dynamicTagsDestinationListingPageOrArticle: ko.observable(false),
      activeVariableType: ko.observable('custom'),
      activeVariableSlot: ko.observable(0),
      imageOverrideVariableName: ko.observable(null),
      swapSource: ko.observable(null),
      vignetteElement: ko.observable(null),
      specsFillMessage: ko.observable(""),
      specsLoading: ko.observable(false),
      isInsertDropdownOpen: ko.observable(false),
      isSingleInsertMode: ko.observable(false),
      hideDestinationContextOptions: ko.observable(false),
      onClickCancel: function (data, event) { self.onClickCancel(); },
      onClickInsert: function (isDynamicPlacement) { self.onClickInsert(!!isDynamicPlacement); },
      onClickToggleInsertDropdown: function (data, event) {
        event.stopPropagation();
        self.insertDropdown.toggle();
      },
      onClickCustomSection: function () { self.onClickVariableSection({ type: 'custom', slot: 0 });},
      onClickBrandSection: function () { self.onClickVariableSection({ type: 'brand', slot: 0 });},
      onClickSelectImage: function () { self.onClickSelectImage(); },
      onClickOverrideImageVariable: function (variable) { self.onClickOverrideImageVariable(variable); },
      isImageUrlVariable: function (variable) { return self.isImageUrlVariable(variable); },

      customVariables: ko.pureComputed(function () {
        return self.getVariablesForType('custom');
      }),
      brandVariables: ko.pureComputed(function () {
        return self.getVariablesForType('brand');
      }),
      tagVariables: ko.pureComputed(function () {
        return self.buildSlotItemsForType('tag');
      }),
      articleVariables: ko.pureComputed(function () {
        return self.buildSlotItemsForType('article');
      }),
      imageVariables: ko.pureComputed(function () {
        return self.buildSlotItemsForType('image');
      }),
      videoVariables: ko.pureComputed(function () {
        return self.buildSlotItemsForType('video');
      }),
      hubVariables: ko.pureComputed(function () {
        return self.buildSlotItemsForType('hub');
      }),
      isCustomVariableSectionActive: ko.pureComputed(function () {
        return self.isActiveVariableSection({ type: 'custom', slot: 0 });
      }),
      isBrandVariableSectionActive: ko.pureComputed(function () {
        return self.isActiveVariableSection({ type: 'brand', slot: 0 });
      }),
      dynamicArticlesDestinationDisabled: ko.pureComputed(function () {
        return self.getTemplateViewModel().dynamicArticlesListingPageSelected()
          || self.getTemplateViewModel().dynamicArticlesAuthorSelected();
      }),
      selectedVariables: ko.pureComputed(function () {
        return self.getSelectedVariables();
      }),
      activeVariableTitle: ko.pureComputed(function () {
        return self.getActiveVariableTitle();
      }),
    };

    return viewModel;
  }

  protected initPartial(): void {
    this.insertDropdown = new InsertDropdownController(this.getTemplateViewModel().isInsertDropdownOpen);

    // embedded tag selector used only for autofilling variables
    this.tagFilter = new filterTag_template("insertFormTagFilter", this.getTemplateViewModel(), this.caller);
    this.tagFilter.setSelectionMode(filterTag_template.SINGLE_SELECTION_MODE);

    this.articleFilter = new filterArticle_template("insertFormArticleFilter", this.getTemplateViewModel(), this.caller);
    this.articleFilter.setIsLoadingAnimationEnable(true);
    this.articleFilter.setSelectionMode(filterArticle_template.SINGLE_SELECTION_MODE);

    this.videoFilter = new filterVideo_template("insertFormVideoFilter", this.getTemplateViewModel(), this.caller);
    this.videoFilter.setIsLoadingAnimationEnable(true);
    this.videoFilter.setSelectionMode(filterVideo_template.SINGLE_SELECTION_MODE);

    this.listingPageFilter = new filterListingPage_template("insertFormListingPageFilter", this.getTemplateViewModel(), this.caller);
    this.listingPageFilter.setShowDetails(true);
    this.listingPageFilter.setPlaceholder("Hub");
    this.listingPageFilter.setIsLoadingAnimationEnable(true);

    this.hubPageFilter = new filterListingPage_template("insertFormHubPageFilter", this.getTemplateViewModel(), this.caller);
    this.hubPageFilter.setShowDetails(true);
    this.hubPageFilter.setPlaceholder("Hub Page");
    this.hubPageFilter.setSelectionMode(filterListingPage_template.SINGLE_SELECTION_MODE);
    this.hubPageFilter.setIsLoadingAnimationEnable(true);

    this.imagePicker = new imagePicker_template("vignetteInsertImagePicker", this.getTemplateViewModel(), this.caller);
    this.imagePicker.setMode("single-select");

    this.authorFilter = new filterUser_template("insertFormAuthorFilter", this.getTemplateViewModel(), this.caller);
    this.authorFilter.setSelectionMode(filterUser_template.SINGLE_SELECTION_MODE);
    this.authorFilter.setPlaceholderText("Author");
    this.authorFilter.setTagContainerId("insert-form-selected-author");
    this.authorFilter.setUniqueIdentifier("insertFormAuthorId");
    this.authorFilter.setIsLoadingAnimationEnable(true);
    this.authorFilter.setNotifyIdElementOnChange(true);

    this.getTemplateViewModel().dynamicArticlesDestinationListingPage.subscribe(() => {
      this.updateDynamicArticleSourceAvailability();
    });
  }

  public setParent(parent){
    this.parent = parent;
  }

  public getVignetteObject(isDynamicPlacement: boolean = false){

    let id = this.getTemplateViewModel().idVignette();
    let name = this.getTemplateViewModel().name();
    let brandOwner = this.getTemplateViewModel().brandOwner();
    let html = this.getTemplateViewModel().html();
    let css = this.getTemplateViewModel().css();
    let variables = this.getTemplateViewModel().variables();
    let references = this.applyDynamicDataSettings(
      Object.assign({}, this.getTemplateViewModel().references() || {})
    );

    return {
      id: id,
      name: name,
      brandOwner: brandOwner,
      html: html,
      css: css,
      variables: variables,
      references: references,
      isDynamicPlacement: !!isDynamicPlacement,
    };
  }

  /**
   * data-references structure:
   *
   * Manual variable selections, stored by slot prefix:
   * - articles: selected custom Article values.
   * - tags: selected custom Tag values.
   * - videos: selected custom Video values.
   * - images: selected custom Image values.
   * - hubs: selected custom Hub values.
   * Each item contains { prefix, id, name, permalink }.
   *
   * Article dynamic source filters:
   * - listingPages: Listing Page selection with
   *   { prefix, id, name, permalink, config }.
   *   `config` is `pinned` or `latest`.
   * - authors: selected Author filter, { prefix, id, name, permalink }.
   *
   * Dynamic destination settings:
   * - allowDynamicDataInsertion: { articles: boolean, hubs: boolean, tags: boolean }.
 */
  public setVignetteData(vignette){

    this.getTemplateViewModel().idVignette(vignette.id);
    this.getTemplateViewModel().name(vignette.name);
    this.getTemplateViewModel().html(vignette.html);
    this.getTemplateViewModel().css(vignette.css);
    this.getTemplateViewModel().brandOwner(vignette.brandOwner);

    let variablesFromCard =  this.getTemplateViewModel().variablesFromCard();
    let variables = this.extractVariablesWithDefaults(vignette.html, variablesFromCard, vignette.css);
    this.getTemplateViewModel().variables(variables);
    this.restoreDynamicDataSettings();
    this.setDefaultActiveVariableSection();

    this.show();
  }

  public setBrandReferences(brandReferences: { [key: string]: any } = {}): void {
    if (!brandReferences || typeof brandReferences !== 'object') {
      return;
    }

    this.fillVariablesFromIndexedValues(brandReferences);

    const vars = Array.isArray(this.getTemplateViewModel().variables())
      ? this.getTemplateViewModel().variables()
      : [];

    vars.forEach((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : '');
      if (parsed.type === 'brand') {
        variable.readOnly = true;
      }
    });
  }

  public extractVariablesWithDefaults(htmlString, overrides, cssString?) {
    // 1) Parse to read any script defaults (without touching DOM)
    var doc = new DOMParser().parseFromString(String(htmlString || ''), 'text/html');

    // 2) Collect script text
    var scriptText = '';
    var scripts = doc.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      scriptText += (scripts[i].textContent || '') + '\n';
    }

    // 3) Simple assignment regex
    var assignRe = /(var|let|const)\s+([A-Za-z_$][A-Za-z0-9_$]*)\s*=\s*(?:'((?:\\.|[^'\\])*)'|"((?:\\.|[^"\\])*)"|`((?:\\.|[^\\`])*)`|([-+]?(?:\d*\.\d+|\d+)(?:[eE][-+]?\d+)?)|(?:\b(true|false|null|NaN|Infinity|-Infinity)\b))\s*;/g;

    // 4) Parse defaults
    var defaults = Object.create(null), m;
    while ((m = assignRe.exec(scriptText)) !== null) {
      var name = m[2], val;
      if      (m[3] != null) val = m[3].replace(/\\'/g, "'").replace(/\\\\/g, "\\");
      else if (m[4] != null) val = m[4].replace(/\\"/g, '"').replace(/\\\\/g, "\\");
      else if (m[5] != null) val = m[5].replace(/\\`/g, "`").replace(/\\\\/g, "\\");
      else if (m[6] != null) val = Number(m[6]);
      else if (m[7] != null) {
        var kw = m[7];
        val = kw === 'true' ? true
            : kw === 'false' ? false
            : kw === 'null' ? null
            : kw === 'NaN' ? NaN
            : kw === 'Infinity' ? Infinity
            : -Infinity;
      } else val = '';
      defaults[name] = val;
    }

    // 5) Collect [[PLACEHOLDER]] names from HTML and CSS
    var placeholderContent = String(htmlString || '') + ' ' + String(cssString || '');
    var placeholderRe = /\[\[\s*([^\]\[]+?)\s*\]\]/g;
    var seen = Object.create(null), names = [], pm;
    while ((pm = placeholderRe.exec(placeholderContent)) !== null) {
      var key = String(pm[1]).trim();
      if (key && !seen[key]) { seen[key] = true; names.push(key); }
    }

    // 6) Build overrides map (unwrap KO observables if any)
    var unwrap = function(v){ return (typeof v === 'function') ? v() : v; };
    var ovMap = Object.create(null);
    if (Array.isArray(overrides)) {
      for (var j = 0; j < overrides.length; j++) {
        var o = overrides[j];
        if (o && o.name) ovMap[o.name] = unwrap(o.value);
      }
    }

    // Helper: get exact or normalized match (_ ↔ -)
    function getMatchingValue(map, name) {
      if (Object.prototype.hasOwnProperty.call(map, name)) {
        return map[name]; // exact match wins
      }
      var alt = name.includes('-') ? name.replace(/-/g, '_') : name.replace(/_/g, '-');
      if (Object.prototype.hasOwnProperty.call(map, alt)) {
        return map[alt]; // fallback normalized match
      }
      return undefined;
    }

    // 7) Final list — override only if placeholder exists
    var out = [];
    for (var k = 0; k < names.length; k++) {
      var nm = names[k];

      var def = getMatchingValue(defaults, nm);
      if (def === undefined) def = '';

      var chosen = getMatchingValue(ovMap, nm);
      if (chosen === undefined) chosen = def;

      out.push({
        name: nm,
        defaultValue: def,
        value: ko.observable(chosen),
        readOnly: false,
      });
    }

    return out;
  }

  public show(){

      this.getTemplateViewModel().isShown(true);
  }

  public hide(){

      this.insertDropdown.close();
      this.getTemplateViewModel().isShown(false);
  }

  public showLoading(){

    let list = document.getElementById("vignette-picker-view");
    list.classList.add("loading")
  }

  public hideLoading(){

    let list = document.getElementById("vignette-picker-view");
    list.classList.remove("loading")
  }

  protected onClickCancel() {
    this.hide();
    this.restPageValues();
  }

  protected onClickInsert(isDynamicPlacement: boolean) {
    this.insertDropdown.close();
    let elementToReplace = this.getTemplateViewModel().vignetteElement();
    let vignetteObject = this.getVignetteObject(isDynamicPlacement);
    this.caller.insertVignetteDisplayCardElement(elementToReplace,vignetteObject);
    this.restPageValues();
    this.getTemplateViewModel().vignetteElement(null);
  }

  public setCaller(caller: any) {
    // ensure nested filter uses the same caller (helper)
    this.caller = caller;
    if (this.tagFilter) {
      this.tagFilter.caller = caller;
    }
    if (this.articleFilter) {
      this.articleFilter.caller = caller;
    }
    if (this.videoFilter) {
      this.videoFilter.caller = caller;
    }
    if (this.imagePicker) {
      this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.getTemplateViewModel(), caller.getVnAppZone(), caller);
      this.imagePicker.setMode("single-select");
    }
    if (this.listingPageFilter) {
      this.listingPageFilter.caller = caller;
    }
    if (this.hubPageFilter) {
      this.hubPageFilter.caller = caller;
    }
    if (this.authorFilter) {
      this.authorFilter.caller = caller;
    }
  }

  public restPageValues(){

    this.getTemplateViewModel().idVignette(null);
    this.getTemplateViewModel().name(null);
    this.getTemplateViewModel().html(null);
    this.getTemplateViewModel().css(null);
    this.getTemplateViewModel().brandOwner(null);
    this.getTemplateViewModel().variables([]);
    this.getTemplateViewModel().variablesFromCard([]);
    this.getTemplateViewModel().references({ articles: [], tags: [], videos: [], images: [], hubs: [], listingPages: [], authors: [] });
    this.getTemplateViewModel().dynamicArticlesDestinationListingPage(false);
    this.getTemplateViewModel().dynamicArticlesSource('latest');
    this.getTemplateViewModel().dynamicArticlesListingPageSelected(false);
    this.getTemplateViewModel().dynamicArticlesAuthorSelected(false);
    this.getTemplateViewModel().dynamicHubsDestinationListingPage(false);
    this.getTemplateViewModel().dynamicTagsDestinationListingPageOrArticle(false);
    this.getTemplateViewModel().activeVariableType('custom');
    this.getTemplateViewModel().activeVariableSlot(0);
    this.getTemplateViewModel().imageOverrideVariableName(null);
    this.getTemplateViewModel().swapSource(null);
    this.updateDynamicArticleSourceAvailability();
  }

  /**
   * Dynamic data is section-wide: it applies to every numbered slot in that
   * section, rather than to an individual article, tag, or hub slot.
   */
  private applyDynamicDataSettings(references: any): any {
    const vm = this.getTemplateViewModel();
    const listingPages = Array.isArray(references.listingPages) ? references.listingPages.slice() : [];
    const articlesDestination = !!vm.dynamicArticlesDestinationListingPage();
    let listingPage = listingPages[0] || null;

    // Listing-page metadata is the Article section's selected source and type.
    // A destination-only choice deliberately has no id/permalink.
    if (articlesDestination && !listingPage) {
      listingPage = { prefix: 'listingPage_default' };
      listingPages.push(listingPage);
    }
    if (listingPage) {
      listingPage.config = vm.dynamicArticlesSource() === 'pinned' ? 'pinned' : 'latest';
      references.listingPages = listingPages;
    }

    // This is new and intentionally separate from the legacy boolean
    // allowDataInsertion, which is left unchanged on existing cards.
    references.allowDynamicDataInsertion = {
      articles: articlesDestination,
      hubs: !!vm.dynamicHubsDestinationListingPage(),
      tags: !!vm.dynamicTagsDestinationListingPageOrArticle()
    };

    return references;
  }

  private restoreDynamicDataSettings(): void {
    const vm = this.getTemplateViewModel();
    const references = vm.references() || {};
    const dynamicData = references.allowDynamicDataInsertion || {};
    const listingPageReference = Array.isArray(references.listingPages) ? references.listingPages[0] || null : null;

    vm.dynamicArticlesDestinationListingPage(dynamicData.articles === true);
    const selectedListingPageType = listingPageReference && listingPageReference.config;
    vm.dynamicArticlesSource(
      selectedListingPageType === 'pinned' ? 'pinned' : 'latest'
    );
    vm.dynamicHubsDestinationListingPage(dynamicData.hubs === true);
    vm.dynamicTagsDestinationListingPageOrArticle(dynamicData.tags === true);

    if (listingPageReference && listingPageReference.id) {
      this.setSelectedListingPage(listingPageReference);
    }

    const author = Array.isArray(references.authors) ? references.authors[0] : null;
    if (author && author.id) {
      this.setSelectedAuthor(author);
    }

    this.updateDynamicArticleSourceAvailability();
  }

  //===============================================
  //variables functions
  private getVariablesForType(type: string): any[] {
    const vm = this.getTemplateViewModel();
    const vars = Array.isArray(vm.variables()) ? vm.variables() : [];

    return vars.filter((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      return parsed.type === type;
    });
  }

  private getVariablesBySlot(type: string): any {
    const variablesBySlot = {};

    this.getVariablesForType(type).forEach((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      this.addVariableToSlot(variablesBySlot, parsed.slot, variable);
    });

    return variablesBySlot;
  }

  private buildSlotItemsForType(type: string): any[] {
    return this.buildSlotItems(type, this.getVariablesBySlot(type));
  }

  private parseVariableName(name: string): any {
    if (/^article_\d+_/.test(name)) {
      const articleMatch = name.match(/^article_(\d+)_(.+)$/);
      return { type: 'article', slot: parseInt(articleMatch[1], 10) - 1, field: articleMatch[2] };
    }
    if (name.indexOf('article_') === 0) {
      return { type: 'article', slot: 0, field: name.replace(/^article_/, '') };
    }
    if (/^image_\d+_/.test(name)) {
      const imageMatch = name.match(/^image_(\d+)_(.+)$/);
      return { type: 'image', slot: parseInt(imageMatch[1], 10) - 1, field: imageMatch[2] };
    }
    if (name.indexOf('image_default_') === 0) {
      return { type: 'image', slot: 0, field: name.replace(/^image_default_/, '') };
    }
    if (/^video_\d+_/.test(name)) {
      const videoMatch = name.match(/^video_(\d+)_(.+)$/);
      return { type: 'video', slot: parseInt(videoMatch[1], 10) - 1, field: videoMatch[2] };
    }
    if (name.indexOf('video_') === 0) {
      return { type: 'video', slot: 0, field: name.replace(/^video_/, '') };
    }
    if (/^hub_\d+_/.test(name)) {
      const hubMatch = name.match(/^hub_(\d+)_(.+)$/);
      return { type: 'hub', slot: parseInt(hubMatch[1], 10) - 1, field: hubMatch[2] };
    }
    if (name.indexOf('hub_') === 0) {
      return { type: 'hub', slot: 0, field: name.replace(/^hub_/, '') };
    }
    if (/^tag_\d+_/.test(name)) {
      const tagMatch = name.match(/^tag_(\d+)_(.+)$/);
      return { type: 'tag', slot: parseInt(tagMatch[1], 10) - 1, field: tagMatch[2] };
    }
    if (name.indexOf('default_') === 0 || name === 'owner_brand_hub_url' || name === 'default_tag_id') {
      return { type: 'tag', slot: 0, field: name.replace(/^default_/, '') };
    }
    if (name.indexOf('brand_') === 0) {
      return { type: 'brand', slot: 0, field: name };
    }

    return { type: 'custom', slot: 0, field: name };
  }

  private addVariableToSlot(collection: any, slot: number, variable: any): void {
    if (!collection[slot]) {
      collection[slot] = [];
    }
    collection[slot].push(variable);
  }

  private buildSlotItems(type: string, variablesBySlot: any): any[] {
    const items = [];
    const slots = Object.keys(variablesBySlot).map((slot) => parseInt(slot, 10)).sort((a, b) => a - b);

    slots.forEach((slot) => {
      const variables = variablesBySlot[slot];
      items.push({
        type: type,
        slot: slot,
        title: ko.pureComputed(() => this.getSlotTitle(type, slot, variables)),
        variables: variables,
        onClick: () => this.onClickVariableSection({ type: type, slot: slot }),
        onClear: () => this.onClearVariableSection({ type: type, slot: slot }),
        onSwap: () => this.onClickSwapSlot({ type: type, slot: slot }),
        hasValue: ko.pureComputed(() => this.slotHasValue(type, slot)),
        showSwap: ko.pureComputed(() => this.shouldShowSwapButton(type, slot)),
        swapLabel: ko.pureComputed(() => this.isSwapSourceSection({ type: type, slot: slot }) ? 'Cancel swap' : 'Swap'),
        isActive: ko.pureComputed(() => this.isActiveVariableSection({ type: type, slot: slot })),
        isSwapSource: ko.pureComputed(() => this.isSwapSourceSection({ type: type, slot: slot }))
      });
    });

    return items;
  }

  private getSlotTitle(type: string, slot: number, variables: any[]): string {
    const label = type.charAt(0).toUpperCase() + type.slice(1);
    const nameValue = this.getSlotNameValue(type, slot, variables);

    return `${label} ${slot + 1}${nameValue ? ' (' + nameValue + ')' : ''}`;
  }

  private getSlotNameValue(type: string, slot: number, variables: any[]): string {
    const nameVar = variables.filter((variable) => {
      if (!variable || !variable.name) {
        return false;
      }
      const parsed = this.parseVariableName(String(variable.name));
      return parsed.type === type && parsed.slot === slot && this.isNameFieldForType(type, parsed.field);
    })[0];
    const value = nameVar ? this.unwrapVariableValue(nameVar.value) : null;

    return value ? String(value) : '';
  }

  private isNameFieldForType(type: string, field: string): boolean {
    if (type === 'video') {
      return field === 'name' || field === 'title' || field === 'default_name' || field === 'default_title';
    }
    if (type === 'article') {
      return field === 'name' || field === 'title' || field === 'default_name' || field === 'default_title';
    }
    if (type === 'image') {
      return field === 'name' || field === 'default_name';
    }
    if (type === 'hub') {
      return field === 'name' || field === 'default_name';
    }
    if (type === 'tag') {
      return field === 'name' || field === 'default_name';
    }

    return false;
  }

  private unwrapVariableValue(value): any {
    return typeof value === 'function' ? value() : value;
  }

  private onClickSwapSlot(section: any): void {
    if (!section || !section.type) {
      return;
    }

    const vm = this.getTemplateViewModel();
    const source = vm.swapSource();
    const slot = typeof section.slot === 'number' ? section.slot : 0;

    if (source && source.type === section.type && source.slot !== slot) {
      this.swapSlots(section.type, source.slot, slot);
      vm.swapSource(null);
      return;
    }

    if (source && source.type === section.type && source.slot === slot) {
      vm.swapSource(null);
      return;
    }

    vm.swapSource({ type: section.type, slot: slot });
  }

  private onClickVariableSection(section: any): void {
    if (!section) {
      return;
    }
    const vm = this.getTemplateViewModel();
    if (section.type === 'custom' || section.type === 'brand') {
      vm.swapSource(null);
    }
    vm.activeVariableType(section.type || 'custom');
    vm.activeVariableSlot(section.slot || 0);
    vm.specsFillMessage("");
    this.clearActiveFilterState(vm.activeVariableType());
  }

  private onClearVariableSection(section: any): void {
    if (!section || section.type === 'brand') {
      return;
    }
    this.clearSlotVariables(section.type, section.slot || 0);
    this.clearReferences(section.type, section.slot || 0);
    const vm = this.getTemplateViewModel();
    const source = vm.swapSource();
    if (source && source.type === section.type && source.slot === (section.slot || 0)) {
      vm.swapSource(null);
    }
    if (this.isActiveVariableSection(section)) {
      this.clearActiveFilterState(section.type);
    }
  }

  private isSwapSourceSection(section: any): boolean {
    const source = this.getTemplateViewModel().swapSource();
    return !!section && !!source && source.type === section.type && source.slot === section.slot;
  }

  private shouldShowSwapButton(type: string, slot: number): boolean {
    if (this.slotHasValue(type, slot) || this.isSwapSourceSection({ type: type, slot: slot })) {
      return true;
    }
    const source = this.getTemplateViewModel().swapSource();
    return !!source && source.type === type && source.slot !== slot;
  }

  private normalizeSlotField(field: string): string {
    const key = String(field || '');
    return key.indexOf('default_') === 0 ? key.replace(/^default_/, '') : key;
  }

  private getSlotFieldValues(type: string, slot: number): { [field: string]: any } {
    const fieldValues: { [field: string]: any } = {};
    const vars = Array.isArray(this.getTemplateViewModel().variables()) ? this.getTemplateViewModel().variables() : [];

    vars.forEach((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      if (parsed.type === type && parsed.slot === slot) {
        fieldValues[this.normalizeSlotField(parsed.field)] = this.unwrapVariableValue(variable.value);
      }
    });

    return fieldValues;
  }

  private applySlotFieldValues(type: string, slot: number, fieldValues: { [field: string]: any }): void {
    const vars = Array.isArray(this.getTemplateViewModel().variables()) ? this.getTemplateViewModel().variables() : [];

    vars.forEach((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      if (parsed.type !== type || parsed.slot !== slot || typeof variable.value !== 'function') {
        return;
      }
      const field = this.normalizeSlotField(parsed.field);
      const nextValue = Object.prototype.hasOwnProperty.call(fieldValues, field) ? fieldValues[field] : '';
      variable.value(nextValue == null ? '' : nextValue);
    });
  }

  private swapSlots(type: string, slotA: number, slotB: number): void {
    if (!type || slotA === slotB) {
      return;
    }

    const valuesA = this.getSlotFieldValues(type, slotA);
    const valuesB = this.getSlotFieldValues(type, slotB);
    this.applySlotFieldValues(type, slotA, valuesB);
    this.applySlotFieldValues(type, slotB, valuesA);
    this.swapReferences(type, slotA, slotB);
  }

  private swapReferences(type: string, slotA: number, slotB: number): void {
    const collectionName = this.getReferenceName(type);
    if (!collectionName) {
      return;
    }

    const vm = this.getTemplateViewModel();
    const references = Object.assign({ articles: [], tags: [], videos: [], images: [], hubs: [], listingPages: [], authors: [] }, vm.references() || {});
    const collection = Array.isArray(references[collectionName]) ? references[collectionName] : [];
    const prefixA = this.getReferencePrefix(type, slotA);
    const prefixB = this.getReferencePrefix(type, slotB);
    const refA = collection.filter((existing) => existing && existing.prefix === prefixA)[0] || null;
    const refB = collection.filter((existing) => existing && existing.prefix === prefixB)[0] || null;
    const nextCollection = collection.filter((existing) => existing && existing.prefix !== prefixA && existing.prefix !== prefixB);

    if (refB) {
      nextCollection.push({ prefix: prefixA, id: refB.id, name: refB.name || '', permalink: refB.permalink || '' });
    }
    if (refA) {
      nextCollection.push({ prefix: prefixB, id: refA.id, name: refA.name || '', permalink: refA.permalink || '' });
    }

    references[collectionName] = nextCollection;
    vm.references(references);
  }

  private slotHasValue(type: string, slot: number): boolean {
    const vm = this.getTemplateViewModel();
    const vars = Array.isArray(vm.variables()) ? vm.variables() : [];

    return vars.some((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      if (parsed.type !== type || parsed.slot !== slot) {
        return false;
      }
      const value = this.unwrapVariableValue(variable.value);
      return value !== null && value !== undefined && String(value).trim() !== "";
    });
  }

  private isActiveVariableSection(section: any): boolean {
    const vm = this.getTemplateViewModel();
    return !!section && vm.activeVariableType() === section.type && vm.activeVariableSlot() === section.slot;
  }

  private getSelectedVariables(): any[] {
    const vm = this.getTemplateViewModel();
    const vars = Array.isArray(vm.variables()) ? vm.variables() : [];
    const activeType = vm.activeVariableType();
    const activeSlot = vm.activeVariableSlot();

    return vars.filter((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      return parsed.type === activeType && parsed.slot === activeSlot;
    });
  }

  private getActiveVariableTitle(): string {
    const type = this.getTemplateViewModel().activeVariableType();
    const slot = this.getTemplateViewModel().activeVariableSlot();
    if (type === 'custom') {
      return 'Custom Fields';
    }
    if (type === 'brand') {
      return 'Brand Fields';
    }

    return `${type.charAt(0).toUpperCase() + type.slice(1)} ${slot + 1}`;
  }

  private setDefaultActiveVariableSection(): void {
    if (this.getVariablesForType('custom').length > 0) {
      this.onClickVariableSection({ type: 'custom', slot: 0 });
      return;
    }

    if (this.getVariablesForType('brand').length > 0) {
      this.onClickVariableSection({ type: 'brand', slot: 0 });
      return;
    }

    const firstItem = this.buildSlotItemsForType('tag')[0]
      || this.buildSlotItemsForType('article')[0]
      || this.buildSlotItemsForType('image')[0]
      || this.buildSlotItemsForType('video')[0]
      || this.buildSlotItemsForType('hub')[0];

    if (firstItem) {
      this.onClickVariableSection(firstItem);
    }
  }

  private getSlotKey(type: string, key: string, slot: number): string {
    if (slot === 0) {
      return key;
    }

    if (type === 'tag') {
      let tagKey = key;
      if (tagKey.indexOf('default_') === 0) {
        tagKey = tagKey.replace(/^default_/, '');
      } else if (tagKey.indexOf('tag_') === 0) {
        tagKey = tagKey.replace(/^tag_/, '');
      }
      return `tag_${slot + 1}_${tagKey}`;
    }

    let itemKey = key;
    if (itemKey.indexOf(`${type}_default_`) === 0) {
      itemKey = itemKey.replace(new RegExp(`^${type}_default_`), '');
    } else if (itemKey.indexOf(`${type}_`) === 0) {
      itemKey = itemKey.replace(new RegExp(`^${type}_`), '');
    }

    return `${type}_${slot + 1}_${itemKey}`;
  }

  private getTagSlotKey(key: string, slot: number): string {
    if (slot === 0) {
      if (key === 'tag_object'
        || key === 'default_tag_id'
        || key === 'owner_brand_hub_url'
        || key === 'default_hub_page_url'
        || key.indexOf('default_') === 0) {
        return key;
      }

      return `default_${key}`;
    }

    let tagKey = key;
    if (tagKey === 'default_tag_id') {
        tagKey = 'id';
    } else if (tagKey.indexOf('default_') === 0) {
        tagKey = tagKey.replace(/^default_/, '');
    } else if (/^tag_\d+_/.test(tagKey)) {
        tagKey = tagKey.replace(/^tag_\d+_/, '');
    } else if (tagKey.indexOf('tag_') === 0 && tagKey !== 'default_tag_id') {
        tagKey = tagKey.replace(/^tag_/, '');
    }

    return `tag_${slot + 1}_${tagKey}`;
  }

  private getReferencePrefix(type: string, slot: number): string {
    if (type === 'tag') {
      return slot === 0 ? 'default' : `tag_${slot + 1}`;
    }
    return slot === 0 ? `${type}_default` : `${type}_${slot + 1}`;
  }

  private getReferenceName(type: string): string {
    if (type === 'article') {
      return 'articles';
    }
    if (type === 'tag') {
      return 'tags';
    }
    if (type === 'video') {
      return 'videos';
    }
    if (type === 'image') {
      return 'images';
    }
    if (type === 'hub') {
      return 'hubs';
    }
    if (type === 'listingPage') {
      return 'listingPages';
    }
    if (type === 'author') {
      return 'authors';
    }
    return '';
  }

  private updateReferences(type: string, slot: number, item: any): void {
    const collectionName = this.getReferenceName(type);
    if (!collectionName || !item || !item.id) {
      return;
    }

    const vm = this.getTemplateViewModel();
    const references = Object.assign({ articles: [], tags: [], videos: [], images: [], hubs: [], listingPages: [], authors: [] }, vm.references() || {});
    const collection = Array.isArray(references[collectionName]) ? references[collectionName] : [];
    const prefix = this.getReferencePrefix(type, slot);
    const nextCollection = collection.filter((existing) => existing && existing.prefix !== prefix);

    nextCollection.push({
      prefix: prefix,
      id: item.id,
      name: item.name || item.title || '',
      permalink: item.permalink || item.urlHubPage || item.url || ''
    });

    references[collectionName] = nextCollection;
    vm.references(references);
  }

  private clearReferences(type: string, slot: number): void {
    const collectionName = this.getReferenceName(type);
    if (!collectionName) {
      return;
    }

    const vm = this.getTemplateViewModel();
    const references = Object.assign({ articles: [], tags: [], videos: [], images: [], hubs: [], listingPages: [], authors: [] }, vm.references() || {});
    const prefix = this.getReferencePrefix(type, slot);
    const collection = Array.isArray(references[collectionName]) ? references[collectionName] : [];
    references[collectionName] = collection.filter((existing) => existing && existing.prefix !== prefix);
    vm.references(references);
  }

  //===============================================
  //tag filter functions
  public getSelectedTags(): any[] {
    if (!this.tagFilter) {
      return [];
    }
    const tagObjs = typeof this.tagFilter.getTagObjs === "function" ? this.tagFilter.getTagObjs() : [];
    if (Array.isArray(tagObjs) && tagObjs.length > 0) {
      return tagObjs;
    }
    const tagObj = typeof this.tagFilter.getTagObj === "function" ? this.tagFilter.getTagObj() : null;
    return tagObj && tagObj.id ? [tagObj] : [];
  }

  public setSelectedTags(tags: any[]): void {
    if (this.tagFilter && typeof this.tagFilter.setTagObjs === "function") {
      this.tagFilter.setTagObjs(tags);
    }
  }

  public setTagFilter(tags: any[]) {
    if (this.tagFilter) {
      this.tagFilter.getTemplateViewModel().tags(tags);
    }
  }

  public getSelectedTagId(): any {
    return this.tagFilter ? this.tagFilter.getTemplateViewModel().idTag() : null;
  }

  public clearTagFilterState() {
    try {
      if (this.tagFilter) {
        this.tagFilter.clearInput();
        const vm = this.tagFilter.getTemplateViewModel();
        if (vm && typeof vm.isShowTagSuggestions === 'function') {
          vm.isShowTagSuggestions(false);
        }
      }
      if (this.articleFilter) {
        this.articleFilter.clearInput();
      }
      if (this.authorFilter) {
        this.authorFilter.clearData();
      }
    } catch (e) {
      // Do nothing
    }
    const formVm = this.getTemplateViewModel();
    if (formVm && typeof formVm.specsFillMessage === 'function') {
      formVm.specsFillMessage("");
    }
    if (formVm && typeof formVm.specsLoading === 'function') {
      formVm.specsLoading(false);
    }
  }

  private fillVariablesFromIndexedValues(indexedHtmlValues: { [key: string]: any }): number {
    const vm = this.getTemplateViewModel();
    const vars = Array.isArray(vm.variables()) ? vm.variables() : [];
    let filledCount = 0;

    for (const v of vars) {
      const key = v && v.name ? String(v.name) : "";
      if (!key) {
        continue;
      }
      const lcKey = key.toLowerCase();
      const index = key in indexedHtmlValues ? key : lcKey in indexedHtmlValues ? lcKey : null;
      if (index !== null) {
        const val = indexedHtmlValues[index];
        const prevVal = (v && typeof v.value === 'function') ? v.value() : (v ? (v as any).value : undefined);
        const isMeaningful = !(val === null || val === undefined || (typeof val === 'string' && val.trim() === ''));
        const changed = String(prevVal) !== String(val);

        if (typeof v.value === 'function') {
          v.value(val);
        }

        if (isMeaningful && changed) {
          filledCount += 1;
        }
      }
    }

    return filledCount;
  }

  private setVariableValue(name: string, value: any): void {
    const vars = Array.isArray(this.getTemplateViewModel().variables()) ? this.getTemplateViewModel().variables() : [];
    const key = String(name || "");
    const variable = vars.filter((item) => item && String(item.name) === key)[0];

    if (variable && typeof variable.value === 'function') {
      variable.value(value);
    }
  }

  private getLastSelectedItem(items: any[]): any {
    if (!Array.isArray(items) || items.length === 0) {
      return null;
    }

    return items[items.length - 1];
  }

  private getActiveSlot(): number {
    const slot = this.getTemplateViewModel().activeVariableSlot();
    return typeof slot === 'number' ? slot : parseInt(slot, 10) || 0;
  }

  private scopeIndexedValuesForActiveSlot(type: string, values: { [key: string]: any }): { [key: string]: any } {
    const scopedValues: { [key: string]: any } = {};
    const slot = this.getActiveSlot();

    for (const key in values) {
      if (Object.prototype.hasOwnProperty.call(values, key)) {
        const slotKey = type === 'tag' ? this.getTagSlotKey(key, slot) : this.getSlotKey(type, key, slot);
        scopedValues[slotKey] = values[key];
      }
    }

    return scopedValues;
  }

  private clearActiveSlotVariables(type: string): void {
    this.clearSlotVariables(type, this.getActiveSlot());
  }

  private clearSlotVariables(type: string, slot: number): void {
    const vm = this.getTemplateViewModel();
    const vars = Array.isArray(vm.variables()) ? vm.variables() : [];
    vars.forEach((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      if (parsed.type === type && parsed.slot === slot && typeof variable.value === 'function') {
        variable.value("");
      }
    });
  }

  private clearVariablesForType(type: string): void {
    const vm = this.getTemplateViewModel();
    const vars = Array.isArray(vm.variables()) ? vm.variables() : [];
    vars.forEach((variable) => {
      const parsed = this.parseVariableName(variable && variable.name ? String(variable.name) : "");
      if (parsed.type === type && typeof variable.value === 'function') {
        variable.value("");
      }
    });
  }

  private clearReferencesForType(type: string): void {
    const collectionName = this.getReferenceName(type);
    if (!collectionName) {
      return;
    }

    const references = Object.assign({ articles: [], tags: [], videos: [], images: [], hubs: [], listingPages: [], authors: [] }, this.getTemplateViewModel().references() || {});
    const collection = Array.isArray(references[collectionName]) ? references[collectionName] : [];
    references[collectionName] = collection.filter((existing) => existing && existing.prefix && existing.prefix.indexOf(type) !== 0);
    this.getTemplateViewModel().references(references);
  }

  private clearActiveFilterState(type: string): void {
    if (type === 'tag' && this.tagFilter) {
      if (typeof this.tagFilter.setTagObjs === 'function') {
        this.tagFilter.setTagObjs([]);
      }
      if (typeof this.tagFilter.clearInput === 'function') {
        this.tagFilter.clearInput();
      }
    } else if (type === 'article' && this.articleFilter) {
      if (typeof this.articleFilter.setArticleObjs === 'function') {
        this.articleFilter.setArticleObjs([]);
      }
      if (typeof this.articleFilter.clearInput === 'function') {
        this.articleFilter.clearInput();
      }
    } else if (type === 'image' && this.imagePicker) {
      if (typeof this.imagePicker.deselectAllImages === 'function') {
        this.imagePicker.deselectAllImages();
      }
    } else if (type === 'video' && this.videoFilter) {
      if (typeof this.videoFilter.setVideoObjs === 'function') {
        this.videoFilter.setVideoObjs([]);
      }
      if (typeof this.videoFilter.clearInput === 'function') {
        this.videoFilter.clearInput();
      }
    } else if (type === 'hub' && this.hubPageFilter) {
      if (typeof this.hubPageFilter.setListingPageObjs === 'function') {
        this.hubPageFilter.setListingPageObjs([]);
      }
      if (typeof this.hubPageFilter.clearInput === 'function') {
        this.hubPageFilter.clearInput();
      }
      if (typeof this.hubPageFilter.resetTagContainer === 'function') {
        this.hubPageFilter.resetTagContainer();
      }
    }
  }

  private buildTagIndexedValues(tag: any, specValues: any[] = [], specDefaults: any[] = [], extraDefaults: { [key: string]: any } = {}): { [key: string]: any } {
    const indexedHtmlValues: { [key: string]: any } = {};
    const fields: any[] = (tag && tag.type && Array.isArray(tag.type.fields)) ? tag.type.fields : null;

    if (fields && fields.length) {
      const allSpecs: any[] = [];
      if (Array.isArray(specDefaults)) {
        for (const item of specDefaults) allSpecs.push(item);
      }
      if (Array.isArray(specValues)) {
        for (const item of specValues) allSpecs.push(item);
      }

      for (const spec of allSpecs) {
        if (!spec || spec.isDefault) {
          continue;
        }
        let tagTypeField: any = null;
        for (const item of fields) {
          if (item && item.id === spec.fieldId) {
            tagTypeField = item;
            break;
          }
        }
        const reference: string = tagTypeField && tagTypeField.reference ? String(tagTypeField.reference).toLowerCase() : "";
        if (!reference) {
          continue;
        }

        let specHtmlValue: any = "";
        if (spec.dataType === "tag") {
          const v0 = (spec.value && spec.value[0]) ? spec.value[0] : null;
          specHtmlValue = v0 ? v0.name : null;
        } else if (spec.dataType === "tags") {
          const values: any = Array.isArray(spec.value) ?
            spec.value : (spec && spec.originalValue && Array.isArray(spec.originalValue) ? spec.originalValue : undefined);
          if (Array.isArray(values)) {
            specHtmlValue = values.map((t: any) => '<span class="' + t.slug + '">' + t.name + '</span>').join("");
          } else {
            specHtmlValue = spec.value;
          }
        } else {
          specHtmlValue = spec.value;
        }

        indexedHtmlValues[reference] = specHtmlValue;
      }
    }

    const defaults: { [key: string]: any } = {};
    defaults.default_tag_id = tag.id != null ? String(tag.id) : "";
    defaults.default_name = tag.name;
    if (tag.type) {
      defaults.default_tag_type = tag.type.name;
      defaults.default_dataset = tag.type.dataset ? tag.type.dataset.name : "";
    }
    if (tag.defaults) {
      defaults.default_color = tag.defaults.color;
      defaults.default_image_url = tag.defaults.image ? tag.defaults.image.url : "";
      defaults.default_banner_image_url = tag.defaults.bannerImage ? tag.defaults.bannerImage.url : "";
      defaults.default_icon_url = tag.defaults.iconImage ? tag.defaults.iconImage.url : "";
      defaults.default_seo_description = tag.defaults.shortDescription;
      defaults.default_review_score = tag.defaults.reviewScore;
      defaults.default_description = tag.defaults.description;
    }
    if (tag.details) {
      if (tag.details.color) defaults.default_color = tag.details.color;
      if (tag.details.image) defaults.default_image_url = tag.details.image.url;
      if (tag.details.bannerImage) defaults.default_banner_image_url = tag.details.bannerImage.url;
      if (tag.details.iconImage) defaults.default_icon_url = tag.details.iconImage.url;
      if (tag.details.shortDescription) defaults.default_seo_description = tag.details.shortDescription;
      if (tag.details.reviewScore) defaults.default_review_score = tag.details.reviewScore;
      if (tag.details.description) defaults.default_description = tag.details.description;
    }
    if (tag && tag.urlHubPage) {
      defaults.owner_brand_hub_url = tag.urlHubPage;
    }
    if (extraDefaults && typeof extraDefaults === 'object') {
      for (const k in extraDefaults) {
        if (Object.prototype.hasOwnProperty.call(extraDefaults, k)) {
          defaults[k] = extraDefaults[k] || '';
        }
      }
    }
    defaults['default_streaming_services_s'] = buildStreamingServiceHtmlFromTag(tag);
    for (const dk in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, dk)) {
        indexedHtmlValues[dk] = defaults[dk];
      }
    }

    return indexedHtmlValues;
  }

  public applyTagsSpecs(tags: any[]) {
    const vm = this.getTemplateViewModel();
    this.clearActiveSlotVariables('tag');
    const tag = this.getLastSelectedItem(tags);

    if (!tag) {
      vm.specsFillMessage("");
      return;
    }

    const tagValues = this.buildTagIndexedValues(
      tag,
      tag.previewSpecValues || [],
      tag.previewSpecDefaults || [],
      tag.previewExtraDefaults || {}
    );
    const indexedHtmlValues = this.scopeIndexedValuesForActiveSlot('tag', tagValues);
    this.updateReferences('tag', this.getActiveSlot(), tag);

    const filledCount = this.fillVariablesFromIndexedValues(indexedHtmlValues);
    this.clearActiveFilterState('tag');
    vm.specsFillMessage(
      filledCount > 0
        ? 'Filled ' + filledCount + ' field' + (filledCount !== 1 ? 's' : '') + ' from tag "' + tag.name + '"'
        : 'No matching fields found in selected tag'
    );
  }

  //===============================================
  //article filter functions
  public getSelectedArticles(): any[] {
    if (!this.articleFilter) {
      return [];
    }
    const articleObjs = typeof this.articleFilter.getArticleObjs === "function" ? this.articleFilter.getArticleObjs() : [];
    if (Array.isArray(articleObjs) && articleObjs.length > 0) {
      return articleObjs;
    }
    const articleObj = typeof this.articleFilter.getArticleObj === "function" ? this.articleFilter.getArticleObj() : null;
    return articleObj && articleObj.id ? [articleObj] : [];
  }

  public setSelectedArticles(articles: any[]): void {
    if (this.articleFilter && typeof this.articleFilter.setArticleObjs === "function") {
      this.articleFilter.setArticleObjs(articles);
    }
  }

  public setArticleFilter(articles: any[]) {
    if (this.articleFilter) {
      this.articleFilter.setOptions(articles);
    }
  }

  public getDefaultIndexedValuesForArticle(article: any): { [key: string]: any } {
    return vignettePreview_template.getDefaultIndexedValuesForArticle(article);
  }

  public applyArticlesSpecs(articles: any[]) {
    const vm = this.getTemplateViewModel();
    this.clearActiveSlotVariables('article');
    const article = this.getLastSelectedItem(articles);

    if (!article) {
      vm.specsFillMessage("");
      return;
    }

    const indexedHtmlValues = this.scopeIndexedValuesForActiveSlot('article', this.getDefaultIndexedValuesForArticle(article));
    this.updateReferences('article', this.getActiveSlot(), article);
    const filledCount = this.fillVariablesFromIndexedValues(indexedHtmlValues);
    this.clearActiveFilterState('article');
    vm.specsFillMessage(
      filledCount > 0
        ? 'Filled ' + filledCount + ' field' + (filledCount !== 1 ? 's' : '') + ' from article "' + article.title + '"'
        : 'No matching fields found in selected article'
    );
  }

  //===============================================
  //image picker functions
  private isImageUrlVariable(variable: any): boolean {
    if (!variable || !variable.name) {
      return false;
    }

    const variableName = String(variable.name).toLowerCase();
    return !!variableName.match(/_image_url$/);
  }

  private onClickOverrideImageVariable(variable: any): void {
    if (!this.isImageUrlVariable(variable)) {
      return;
    }

    this.getTemplateViewModel().imageOverrideVariableName(variable.name);
    this.openImagePicker();
  }

  public onClickSelectImage(): void {
    this.getTemplateViewModel().imageOverrideVariableName(null);
    this.openImagePicker();
  }

  private openImagePicker(): void {
    if (!this.imagePickerHelper || !this.imagePicker) {
      return;
    }

    this.imagePicker.setIsImageOptimizable(false);
    this.imagePicker.setMode("single-select");
    this.imagePicker.setTarget("vignette_insert_image");
    this.imagePicker.setSelectedImages([]);
    this.imagePickerHelper.getImageData();
    this.imagePicker.show();
    this.bindImagePickerScroll();
  }

  protected bindImagePickerScroll(): void {
    if (this.imagePickerScrollBound || !this.imagePicker || !this.imagePickerHelper) {
      return;
    }

    const pickerRoot = document.getElementById("vignetteInsertImagePicker");
    const imageResultsList = pickerRoot ? pickerRoot.querySelector('[id="image-results-list"]') as HTMLElement : null;
    if (!imageResultsList) {
      return;
    }

    imageResultsList.addEventListener("scroll", () => {
      const imagePickerVm = this.imagePicker.getTemplateViewModel();
      const imagePickerState = this.imagePicker as any;

      if (!imagePickerVm.isShown() || imagePickerVm.selectedTab() !== "images") {
        return;
      }

      const isNearBottom = imageResultsList.scrollTop !== 0
        && imageResultsList.scrollTop + imageResultsList.clientHeight >= imageResultsList.scrollHeight - 100;

      if (!isNearBottom || imagePickerState.imageNextpageRequested) {
        return;
      }

      if (imagePickerVm.imagePagination.pageNumber() >= imagePickerVm.imagePagination.pageMax()) {
        return;
      }

      imagePickerVm.imagePagination.pageNumber(imagePickerVm.imagePagination.pageNumber() + 1);
      imagePickerVm.imagePagination.reuseTotalCount = imagePickerVm.imagePagination.totalCount;
      imagePickerState.imageNextpageRequested = true;
      this.imagePickerHelper.getImageData();
    });

    this.imagePickerScrollBound = true;
  }

  public getDefaultIndexedValuesForImage(image: any): { [key: string]: any } {
    if (!image) {
      return {};
    }

    return {
      image_default_name: image.name || "",
      image_default_url: image.url || "",
      image_default_alt_text: image.altText || "",
    };
  }

  public applyImageSpecs(image: any) {
    const vm = this.getTemplateViewModel();

    if (!image) {
      vm.specsFillMessage("");
      return;
    }

    const overrideVariableName = vm.imageOverrideVariableName();
    if (overrideVariableName) {
      this.setVariableValue(overrideVariableName, image.url || "");
      vm.imageOverrideVariableName(null);
      vm.specsFillMessage('Updated "' + overrideVariableName + '" from image "' + (image.name || image.url || image.id) + '"');
      return;
    }

    this.clearActiveSlotVariables('image');

    const indexedHtmlValues = this.scopeIndexedValuesForActiveSlot('image', this.getDefaultIndexedValuesForImage(image));
    this.updateReferences('image', this.getActiveSlot(), image);
    const filledCount = this.fillVariablesFromIndexedValues(indexedHtmlValues);
    this.clearActiveFilterState('image');
    vm.specsFillMessage(
      filledCount > 0
        ? 'Filled ' + filledCount + ' field' + (filledCount !== 1 ? 's' : '') + ' from image "' + (image.name || image.url || image.id) + '"'
        : 'No matching fields found in selected image'
    );
  }

  //===============================================
  //video filter functions
  public getSelectedVideos(): any[] {
    if (!this.videoFilter) {
      return [];
    }
    const videoObjs = typeof this.videoFilter.getVideoObjs === "function" ? this.videoFilter.getVideoObjs() : [];
    if (Array.isArray(videoObjs) && videoObjs.length > 0) {
      return videoObjs;
    }
    const videoObj = typeof this.videoFilter.getVideoObj === "function" ? this.videoFilter.getVideoObj() : null;
    return videoObj && videoObj.id ? [videoObj] : [];
  }

  public setSelectedVideos(videos: any[]): void {
    if (this.videoFilter && typeof this.videoFilter.setVideoObjs === "function") {
      this.videoFilter.setVideoObjs(videos);
    }
  }

  public clearVideoFilterInput(): void {
    if (this.videoFilter && typeof this.videoFilter.clearInput === "function") {
      this.videoFilter.clearInput();
    }
  }

  public setVideoFilter(videos: any[]) {
    if (this.videoFilter) {
      this.videoFilter.setOptions(videos);
    }
  }

  public getDefaultIndexedValuesForVideo(video: any): { [key: string]: any } {
    return {
      video_default_name: video.title || "",
      video_default_url: video.url || "",
      video_default_thumbnail_url: video.thumbnail ? video.thumbnail.url : "",
      video_default_description: video.description || "",
      video_default_length: video.length || "",
      video_default_mime_type: video.mimeType || "",
      video_default_width: video.width || "",
      video_default_height: video.height || "",
      video_default_ratio: video.ratio || "",
      video_default_primary_content_type: video.details && video.details.contentType ? video.details.contentType.name : "",
      video_default_primary_content_type_color: video.details && video.details.contentType ? video.details.contentType.color : "",
      video_default_primary_category: video.details && video.details.primaryCategory ? video.details.primaryCategory.name : "",
      video_default_primary_tag: video.details && video.details.primaryTag ? video.details.primaryTag.name : "",
    };
  }

  public applyVideosSpecs(videos: any[]) {
    const vm = this.getTemplateViewModel();
    this.clearActiveSlotVariables('video');
    const video = this.getLastSelectedItem(videos);

    if (!video) {
      vm.specsFillMessage("");
      return;
    }

    const indexedHtmlValues = this.scopeIndexedValuesForActiveSlot('video', this.getDefaultIndexedValuesForVideo(video));
    this.updateReferences('video', this.getActiveSlot(), video);
    const filledCount = this.fillVariablesFromIndexedValues(indexedHtmlValues);
    this.clearActiveFilterState('video');
    vm.specsFillMessage(
      filledCount > 0
        ? 'Filled ' + filledCount + ' field' + (filledCount !== 1 ? 's' : '') + ' from video "' + video.title + '"'
        : 'No matching fields found in selected video'
    );
  }

  //===============================================
  //hub filter functions
  public getSelectedHubPages(): any[] {
    if (!this.hubPageFilter) {
      return [];
    }
    const listingPageObj = typeof this.hubPageFilter.getListingPageObj === "function" ? this.hubPageFilter.getListingPageObj() : null;
    if (listingPageObj && listingPageObj.id) {
      return [listingPageObj];
    }
    const listingPageObjs = typeof this.hubPageFilter.getListingPageObjs === "function" ? this.hubPageFilter.getListingPageObjs() : [];
    if (Array.isArray(listingPageObjs) && listingPageObjs.length > 0) {
      return listingPageObjs;
    }
    return [];
  }

  public setHubPageFilter(listingPages: any[]) {
    if (this.hubPageFilter) {
      this.hubPageFilter.setOptions(listingPages);
    }
  }

  public getDefaultIndexedValuesForHub(hub: any): { [key: string]: any } {
    return {
      hub_default_name: hub.name || "",
      hub_default_url: hub.permalink || "",
      hub_default_description: hub.description || "",
      hub_default_thumbnail_image_url: hub.thumbnailImage ? hub.thumbnailImage.url : "",
      hub_default_banner_image_url: hub.bannerImage ? hub.bannerImage.url : "",
    };
  }

  public applyHubPageSpecs(hubPages: any[]) {
    const vm = this.getTemplateViewModel();
    this.clearActiveSlotVariables('hub');
    const hub = this.getLastSelectedItem(hubPages);

    if (!hub) {
      vm.specsFillMessage("");
      return;
    }

    const indexedHtmlValues = this.scopeIndexedValuesForActiveSlot('hub', this.getDefaultIndexedValuesForHub(hub));
    this.updateReferences('hub', this.getActiveSlot(), hub);
    const filledCount = this.fillVariablesFromIndexedValues(indexedHtmlValues);
    this.clearActiveFilterState('hub');
    vm.specsFillMessage(
      filledCount > 0
        ? 'Filled ' + filledCount + ' field' + (filledCount !== 1 ? 's' : '') + ' from hub "' + hub.name + '"'
        : 'No matching fields found in selected hub'
    );
  }

  //===============================================
  //listing page filter functions
  public getSelectedListingPage(): any {
    if (!this.listingPageFilter) {
      return null;
    }
    const vm = this.listingPageFilter.getTemplateViewModel();
    return vm && typeof vm.listingPageObj === 'function' ? vm.listingPageObj() : null;
  }

  public setListingPageFilter(listingPages: any[]) {
    if (this.listingPageFilter) {
      this.listingPageFilter.setOptions(listingPages);
    }
  }

  public setSelectedListingPage(listingPage: any): void {
    if (this.listingPageFilter && typeof this.listingPageFilter.setListingPage === "function") {
      this.listingPageFilter.setListingPage(listingPage);
    }
  }

  public clearListingPageFilterInput(): void {
    if (this.listingPageFilter && typeof this.listingPageFilter.clearInput === "function") {
      this.listingPageFilter.clearInput();
    }
  }

  /** A single listing page feeds every article slot, so its reference is always kept on the first slot. */
  public applyListingPageSpecs(listingPage: any) {
    const vm = this.getTemplateViewModel();
    this.clearReferencesForType('listingPage');

    if (!listingPage) {
      this.clearListingPageContextVariables();
      vm.specsFillMessage("");
      this.updateDynamicArticleSourceAvailability();
      return;
    }

    this.updateReferences('listingPage', 0, listingPage);
    const filledCount = this.fillListingPageContextVariables(listingPage);
    vm.specsFillMessage(
      filledCount > 0
        ? 'Filled ' + filledCount + ' listing-page context field' + (filledCount !== 1 ? 's' : '') + ' from "' + (listingPage.name || listingPage.permalink || listingPage.id) + '"'
        : 'Hub selected for article placeholders'
    );
    this.updateDynamicArticleSourceAvailability();
  }

  private getDefaultIndexedValuesForListingPageContext(listingPage: any): { [key: string]: any } {
    if (!listingPage) {
      return {};
    }

    const imageUrl = listingPage.featuredImage
      ? (listingPage.featuredImage.url || listingPage.featuredImage.src || '')
      : (listingPage.thumbnailImage ? listingPage.thumbnailImage.url : '');
    const bannerUrl = listingPage.bannerImage ? listingPage.bannerImage.url : imageUrl;
    const name = listingPage.name || '';
    const permalink = listingPage.permalink || '';
    const description = listingPage.description || '';
    const articleCount = Math.max(0, parseInt(String(listingPage.articleCount != null ? listingPage.articleCount : 0), 10) || 0);
    const articlesUrl = articleCount > 0 && permalink
      ? String(permalink).replace(/\/?$/, '/') + 'articles/'
      : '';

    return {
      listing_page_default_name: name,
      listing_page_default_url: permalink,
      listing_page_default_description: description,
      listing_page_default_thumbnail_image_url: imageUrl,
      listing_page_default_banner_image_url: bannerUrl,
      listing_page_default_article_count: String(articleCount),
      listing_page_default_articles_url: articlesUrl,
    };
  }

  private fillListingPageContextVariables(listingPage: any): number {
    const contextValues = this.getDefaultIndexedValuesForListingPageContext(listingPage);
    const vars = Array.isArray(this.getTemplateViewModel().variables()) ? this.getTemplateViewModel().variables() : [];
    let filledCount = 0;

    vars.forEach((variable) => {
      if (!variable || !variable.name || typeof variable.value !== 'function') {
        return;
      }

      const key = String(variable.name);
      if (!Object.prototype.hasOwnProperty.call(contextValues, key)) {
        return;
      }

      const nextValue = contextValues[key];
      if (nextValue === null || nextValue === undefined || nextValue === '') {
        return;
      }

      const currentValue = this.unwrapVariableValue(variable.value);
      if (String(currentValue) !== String(nextValue)) {
        variable.value(nextValue);
        filledCount += 1;
      }
    });

    return filledCount;
  }

  private clearListingPageContextVariables(): void {
    const vars = Array.isArray(this.getTemplateViewModel().variables()) ? this.getTemplateViewModel().variables() : [];
    vars.forEach((variable) => {
      if (!variable || !variable.name || typeof variable.value !== 'function') {
        return;
      }
      if (String(variable.name).indexOf('listing_page_') === 0) {
        variable.value('');
      }
    });
  }

  //===============================================
  //author filter functions
  public getSelectedAuthor(): any {
    if (!this.authorFilter || typeof this.authorFilter.getUserObject !== "function") {
      return null;
    }
    const author = this.authorFilter.getUserObject();

    return author && author.id ? author : null;
  }

  public setAuthorFilter(users: any[]) {
    if (this.authorFilter && typeof this.authorFilter.setUsers === "function") {
      this.authorFilter.setUsers(users);
    }
  }

  public setSelectedAuthor(author: any): void {
    if (!this.authorFilter || !author || !author.id) {
      return;
    }
    this.authorFilter.setUserObject(author);
    this.authorFilter.setIdUser(author.id);
    this.authorFilter.setUser(author.name || '');
    this.authorFilter.toggleCloseButton();
  }

  /** A single author feeds every article slot, so its reference is always kept on the first slot. */
  public applyAuthorSpecs(author: any) {
    const vm = this.getTemplateViewModel();

    if (!author) {
      this.clearReferences('author', 0);
      vm.specsFillMessage("");
      this.updateDynamicArticleSourceAvailability();
      return;
    }

    this.updateReferences('author', 0, this.getAuthorReferenceData(author));
    this.updateDynamicArticleSourceAvailability();
  }

  private updateDynamicArticleSourceAvailability(): void {
    const vm = this.getTemplateViewModel();
    const destinationSelected = !!vm.dynamicArticlesDestinationListingPage();
    const listingPageSelected = !!this.getSelectedListingPage();
    const authorSelected = !!this.getSelectedAuthor();
    vm.dynamicArticlesListingPageSelected(listingPageSelected);
    vm.dynamicArticlesAuthorSelected(authorSelected);

    if (this.listingPageFilter && typeof this.listingPageFilter.setDisabled === 'function') {
      this.listingPageFilter.setDisabled(destinationSelected || authorSelected);
    }
    if (this.authorFilter && typeof this.authorFilter.setDisabled === 'function') {
      this.authorFilter.setDisabled(destinationSelected || listingPageSelected);
    }
  }

  private getAuthorReferenceData(author: any): any {
    const valnetUser = author && author.valnet_user ? author.valnet_user : null;

    return {
      id: author.id,
      name: valnetUser && valnetUser.fullName ? valnetUser.fullName : (author.name || '')
    };
  }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettePickerInsertForm_template.ts